import emitter from "./event-bus";
import { lockBodyScroll, unlockBodyScroll } from "./scroll-lock";

document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("terms-conditions");
    if (!modal) return;

    const content = modal.querySelector<HTMLElement>("[data-modal-content]");
    const dismissButtons = modal.querySelectorAll<HTMLButtonElement>("[data-modal-dismiss]");

    const setState = (state: "open" | "closed") => {
        modal.dataset.state = state;
        if (state === "open") lockBodyScroll("terms");
        else unlockBodyScroll("terms");

        if (state == "closed") {
            emitter.emit("close:terms");
        }
    };

    const isOpen = () => modal.dataset.state === "open";
    const open = () => setState("open");
    const close = () => setState("closed");

    emitter.on("show:terms", open);

    modal.addEventListener("click", e => {
        if (e.target === modal && isOpen()) close();
    });

    content?.addEventListener("click", e => e.stopPropagation());

    dismissButtons.forEach(btn => btn.addEventListener("click", () => close()));

    document.addEventListener("keydown", e => {
        if (e.key === "Escape" && isOpen()) {
            close();
        }
    });
});
